import { HeadingH1, HeadingH4 } from '@dreamstack/feature-components/src/layout/Texts'
import type { BlockTable } from '@dreamstack/payload/src/payload-types'
import { clsxMerge } from '@dreamstack/util'
import head from 'lodash/head'
import map from 'lodash/map'
import tail from 'lodash/tail'
import type { FunctionComponent } from 'react'

// Tailwind refactor: replaced styled components with direct tr/td elements and conditional classes.
// Preserved alternating background logic and spacing.

export const TableGreyWhiteAlternating: FunctionComponent<
  React.PropsWithChildren<{
    block: BlockTable
  }>
> = ({ block }) => {
  const { title, table } = block
  const tableData =
    (table as { tableData?: string[][] } | null)?.tableData ?? null
  const headData: string[] | undefined = head(tableData)
  const rowData: string[][] = tail(tableData) || [[]]
  return (
    //TODO: how to give different width to the first column?
    <div className="w-full mt-px-48 md:mt-px-80">
      {title && <HeadingH1 className="mb-px-24">{title}</HeadingH1>}
      <div className="w-full overflow-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-accentroGray-full">
              {map(headData, (headDataEntry, i) => (
                <th
                  className="px-px-8 py-px-24 text-left mx-px-12 md:p-px-24 align-middle"
                  key={i}
                >
                  <HeadingH4>{headDataEntry}</HeadingH4>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {map(rowData, (rowEntry, idx) => {
              const isEven = idx % 2 === 0
              return (
                <tr
                  key={idx}
                  className={clsxMerge(
                    'py-px-32 align-middle',
                    isEven ? 'bg-accentroWhite-full' : 'bg-accentroGray-50'
                  )}
                >
                  {map(rowEntry, (rowEntryData, i) => (
                    <td
                      key={`rowdataentry${i}`}
                      className="px-px-8 py-px-24 text-left md:p-px-24 align-middle"
                    >
                      <HeadingH4 style={{ fontWeight: 'normal' }}>
                        {rowEntryData}
                      </HeadingH4>
                    </td>
                  ))}
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}
